import { render } from "./ChartList.vue?vue&type=template&id=f81fca86"
import script from "./ChartList.vue?vue&type=script&lang=js"
export * from "./ChartList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__